import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    role,
    perms = {},
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.perms.setPermBatch, {
        role,
        perms,
    }, options);
    if (error) return { error, status };
    return content || {};
};
